import RemoteTeacher from "../models/RemoteTeacher"
import { billRequests } from "../views/Administrator/PaymentMails"
import { DateInterval } from "../views/components/Utils/DatePickerButton"
import sendMails from "./sendPaymentMails"

export default (dateInterval: DateInterval, teachers: RemoteTeacher[]) =>
 sendMails({ type: 'SEND_BILLREQUESTS', route: 'billRequests', pluralMailConcept: billRequests, dateInterval, teachers })